import script from "./NewsDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsDetail.vue?vue&type=script&setup=true&lang=ts"

import "./NewsDetail.vue?vue&type=style&index=0&id=60493310&lang=scss&scoped=true"

import exportComponent from "/Users/mayo/htdocs/halp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60493310"]])

export default __exports__